// Font Types
enum Fonts {
  fontello = 'fontello',
  gilroySB = 'Gilroy-SemiBold',
  gilroyR = 'Gilroy-Regular',
  interR = 'Inter-Regular',
  interSB = 'Inter-SemiBold',
  montserrat = 'Montserrat',
}

type FontType = Fonts.fontello | Fonts.montserrat | Fonts.gilroySB | Fonts.gilroyR | Fonts.interR | Fonts.interSB;

// Palette
enum Colors {
  martinique = '#2b2f67',
  softMartinique = '#4f538b',
  pelorous = '#1884ac',
  summerSky = '#2aa5de',
  summerSky200 = '#e9f6fc',
  goldenrod = '#f09d40',
  spray = '#76cdd5',
  carnation = '#e44f43',
  matterhorn = '#4e4e4e',
  silver = '#8d8d8d',
  black = '#000',
  gold = '#ffd700',
  indigo = '#0d4066',
  mist = '#f3f5f5',
  royalBlue = '#3d6edf',
  sky = '#36c6ff',
  teal = '#1794a5',
  spring = '#49e8ab',
  iris = '#8c52ff',
  lilac = '#bf94ff',
  powderBlue = '#c7e3ff',
  oat = '#f4f0e6',
  richBlack = '#2d2926',
  coolGray = '#53565a',
  gray = '#a3a3a3',
  lightGray = '#dddddd',
  ashGray = '#e5e5e5',
  white = '#ffffff',
  mint = '#00b286',
  darkMint = '#007558',
  amber = '#fdc913',
  strawberry = '#ee2045',
  darkStrawberry = '#ce2543',
  lightTan = '#FFE9C7',
}

export { Fonts, FontType, Colors };
